import { Injectable } from '@angular/core';
import { IResponse, SearchUser } from '@interfaces/index';
import { HttpService } from '@ui-components/services';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(
    protected _http_service: HttpService
  ) { }

  search(person_id: number, search_string: string): Observable<IResponse<{ content: SearchUser[] }>> {
    return this._http_service.post('persons/search', {
      person_id,
      search_string
    })
  }
}